<template>
    <div class="card-accordion" :class="{ 'toggled': expanded }">
        <div class="pb__left">
            <h3 class="h6">{{ job.status }}</h3>
        </div>

        <div class="pb__right">
            <p class="h4">{{ job.details.name }}</p>
            <div v-if="expanded" class="pb__right-wrap">
                <div>
                    <p class="h6 mb-sm">Address</p>
                    <p v-if="job.details.address.string">{{ job.details.address.string }} <a v-if="job.details.address.string" class="link nowrap" :href="`https://maps.google.com/?q=${job.details.address.string}`" target="_blank">View map</a></p>
                    <p v-else>-</p>
                </div>
                <div>
                    <p class="h6 mb-sm">System Size (kW)</p>
                    <p v-if="job.details.systemSize">{{ job.details.systemSize / 1000 }}</p>
                    <p v-else>-</p>
                </div>
                <div>
                    <p class="h6 mb-sm">Date created</p>
                    <p>{{ job.dateCreated | date }}</p>
                </div>

                <div>
                    <p class="h6 mb-sm">Accreditation No.</p>
                    <p v-if="job.details.accreditationNumber">{{ job.details.accreditationNumber }}</p>
                    <p v-else>-</p>
                </div>
                <div class="mt-md">
                    <a class="btn" :href="`/account/job/${job.id}`">View job</a>
                </div>
            </div>
        </div>

        <div class="card-accordion__toggle expand" @click="expanded = !expanded">
            <svg class="icon expand__plus-outline">
                <use xlink:href="#plus-outline" />
            </svg>
            <svg class="icon expand__plus-solid">
                <use xlink:href="#plus-solid" />
            </svg>
            <svg class="icon expand__minus-outline">
                <use xlink:href="#minus-outline" />
            </svg>
            <svg class="icon expand__minus-solid">
                <use xlink:href="#minus-solid" />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    filters: {
        date(val) {
            const date = new Date(val);
            return date.toLocaleDateString();
        }
    },

    props: {
        job: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            expanded: false
        };
    }
};
</script>
